/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { FC, useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  IconButton,
  Link,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useToast
} from '@chakra-ui/react'

import { AiOutlineDelete, AiOutlineUser } from 'react-icons/ai'
import { RiAddLine, RiEye2Fill, RiPencilLine } from 'react-icons/ri'
import { AlertDialogCustom } from '../../Components/AlertDialog'
import { Header } from '../../Components/Header'
import { SearchBox } from '../../Components/Header/SearchBox'
import { Pagination } from '../../Components/Pagination'
import { Sidebar } from '../../Components/Sidebar'
import api from '../../Services/api'
import { format } from 'date-fns'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { Can } from '../../Components/Can'
import debounce from 'lodash.debounce'

interface Process {
  id: string
  cod: string
  cod_prefecture: string
  status: 'CREATED'
  created_at: string
  net: {
    id: string
    name: string
  }
  unit: {
    id: string
    name: string
  }
  proposal: {
    id: string
    number: string
  }
  technical: {
    id: string
    name: string
  }
}

const ProcessList: FC = () => {
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [data, setData] = useState<Process[]>([])
  const [error, setError] = useState(false)
  const [total, setTotal] = useState(10)
  const [selectedItem, setSelectedItem] = useState<Process>({} as Process)
  const toast = useToast()

  const location = useLocation()
  const parsed = queryString.parse(location.search)
  const unitId = parsed.unit

  const STATUS = {
    CREATED: 'Criado'
  }

  const isWideScreen = useBreakpointValue({
    base: false,
    lg: true
  })

  const load = useCallback(async (pag: number) => {
    console.log('chamou o load')
    setLoading(true)
    try {
      const { data } = await api.get('/process', {
        params: {
          pag,
          unit_id: unitId
        }
      })

      const normalize = await Promise.all(data.data.map(async (i: any) => {
        return {
          ...i,
          created_at: format(new Date(i.created_at), 'dd/MM/yyyy')
        }
      }))

      setPage(pag)
      setData([...normalize])
      setTotal(data.total)
    } catch (error) {
      console.log('erro ao pegar administradores: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
    // setData(fakeData)
  }, [unitId])

  useEffect(() => {
    load(page)
  }, [page])

  const hanleDelete = useCallback(async () => {
    const { id } = selectedItem
    try {
      await api.delete(`/process/${id}`)

      toast({
        title: 'Deletado com sucesso',
        position: 'top',
        isClosable: true,
        status: 'success',
        variant: 'solid'
      })
      setSelectedItem({} as Process)
      // load(page);
    } catch (error) {
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
      setSelectedItem({} as Process)
    }
  }, [selectedItem, toast])

  const closeModal = useCallback(() => {
    setSelectedItem({} as Process)
  }, [])

  const handleFilterList = useCallback(async (e: any) => {
    setLoading(true)

    try {
      const { data } = await api.get('/process', {
        params: {
          pag: 1,
          search: e
        }
      })

      const normalize = await Promise.all(data.data.map(async (i: any) => {
        return {
          ...i,
          created_at: format(new Date(i.created_at), 'dd/MM/yyyy')
        }
      }))

      // setPage(1)
      setData([...normalize])
      setTotal(data.total)
    } catch (error) {
      console.log('erro ao pegar lista: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  const debouncedFetch = useCallback(
    debounce(async (value) => await handleFilterList(value), 1500), // 500ms de atraso
    [handleFilterList]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true)
    const value = e.target.value
    debouncedFetch(value)
  }

  return (
    <Can permissions={['proccess.list', 'proccess.create', 'proccess.all']} page>
    <Box>
      {!!selectedItem?.id && (
        <AlertDialogCustom
          title="Deletar Processo"
          isOpen={!!selectedItem?.id}
          cancelFunction={closeModal}
          nextFunction={hanleDelete}
        />
      )}
      <Header />

      <Flex w="100%" my="6" maxWidth={1480} mx="auto" px={['4', '4', '6']}>
        <Sidebar />

        <Box flex="1" borderRadius={8} bg="white" p="8">
          <Flex mb="8" justify="space-between" align="center">
            <Heading size="lg" fontWeight="normal" color="wine.primary">
              Processos
              {/* { !loading && isRefetching && <Spinner size="sm" ml="4" color="pink.400" />} */}
              {unitId && <Text size="sm" fontSize="14">
              {unitId && !!data?.length && data[0]?.unit?.name}
              </Text>
}
            </Heading>

            <SearchBox placeholder="Buscar..." onChangeFunction={handleInputChange}/>

            {/* <Button
              as="a"
              href="/pre-proposal/create"
              size="sm"
              fontSize="sm"
              bg="wine.primary"
              _hover={{ bgColor: 'wine.200' }}
              color="white"
              leftIcon={<Icon as={RiAddLine} fontSize="20" />}
            >
              Criar nova pré-proposta
            </Button> */}

            {/* <NextLink href="/users/create" passHref>
                            <Button as="a" size="sm" fontSize="sm" colorScheme="blue" leftIcon={<Icon as={RiAddLine} fontSize="20" />}>
                                Criar Usuário
                            </Button>
                        </NextLink> */}
          </Flex>

          {loading ? (
            <Flex justify="center">
              <Spinner />
            </Flex>
          ) : error ? (
            <Flex justify="center">
              <Text>Erro ao carregar a lista de processos</Text>
            </Flex>
          ) : (
            <>
              <Table colorScheme="blue">
                <Thead>
                  <Tr>

                    <Th textAlign="center" fontSize={12}>Cliente</Th>
                    <Th textAlign="center" fontSize={12}>Unidade</Th>
                    <Th textAlign="center" fontSize={12}>Proposta</Th>
                    <Th textAlign="center" fontSize={12}>Nº Processo</Th>
                    <Th textAlign="center" fontSize={12}>Resp. Técnico</Th>
                    <Th textAlign="center" fontSize={12}>Criação</Th>
                    {/* <Th textAlign="center" fontSize={12}>Status</Th> */}

                    <Th w="8"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data?.map((i) => (
                    <Tr key={i.id}>

                      <Td>
                          <Link color="wine.500" textAlign="center" fontSize={14}>
                            <Text fontWeight="bold">{i.net.name}</Text>
                          </Link>
                      </Td>

                      <Td>
                          <Link color="wine.500" textAlign="center" fontSize={14}>
                            <Text fontWeight="bold">{i.unit.name}</Text>
                          </Link>
                      </Td>

                      <Td>
                          <Link color="wine.500" textAlign="center">
                            <Text fontWeight="bold">{i.proposal.number}</Text>
                          </Link>
                      </Td>

                      <Td>
                          <Link color="wine.500" textAlign="center" fontSize={14}>
                            <Text fontWeight="bold">{i.cod_prefecture}</Text>
                          </Link>
                      </Td>

                      <Td>
                          <Link color="wine.500" textAlign="center" fontSize={14}>
                            <Text fontWeight="bold">{i?.technical?.name}</Text>
                          </Link>
                      </Td>

                      <Td>
                          <Link color="wine.500" fontSize={14}>
                            <Text fontWeight="bold" textAlign="center">{i?.created_at}</Text>
                          </Link>
                      </Td>

                      {/* <Td>
                          <Link color="wine.500" fontSize={14}>
                            <Text fontWeight="bold" textAlign="center">{STATUS[i.status]}</Text>
                          </Link>
                      </Td> */}

                      <Td>
                        <Flex>
                          {/* {isWideScreen ? (
                            <Button
                              as="button"
                              size="sm"
                              fontSize="sm"
                              mr="2"
                              colorScheme="teal"
                              leftIcon={
                                <Icon as={AiOutlineUser} fontSize="16" />
                              }
                            >
                              Perfil
                            </Button>
                          ) : (
                            <IconButton
                              mr="3"
                              colorScheme="teal"
                              aria-label="Edit Content"
                              icon={<Icon as={AiOutlineUser} size="30" />}
                            />
                          )} */}

{isWideScreen
  ? (
                              <Button
                              href={`/process/create/${i.id}`}
                                as="a"
                                size="sm"
                                fontSize="sm"
                                mr="2"
                                bg="wine.200"
                                colorScheme="wine"
                                leftIcon={
                                  <Icon as={RiEye2Fill} fontSize="16" />
                                }
                              >
                              Visualizar
                            </Button>
    )
  : (
                            <IconButton
                              mr="3"
                              colorScheme="green"
                              aria-label="Edit Content"
                              icon={<Icon as={RiPencilLine} size="30" />}
                            />
    )}
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>

              <Pagination
                totalCountOfRegisters={total}
                currentPage={page}
                onPageChange={setPage}
              />
            </>
          )}
        </Box>
      </Flex>
    </Box>
    </Can>
  )
}

export { ProcessList }
